














































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { TextoEditavel } from '../../../../back/src/entity/TextoEditavel';

export default Vue.extend({
  name: 'TextosEditaveisIndex',
  components: {
  },
  data() {
    return {
      loading: false,
      textosEditaveis: [] as TextoEditavel[],
    };
  },
  computed: {
    headers() {
      return [
        {
          value: 'id',
          text: 'Id ',
          sortable: true,
        },
        {
          value: 'nome',
          text: 'Nome ',
          sortable: true,
        },
        {
          value: 'texto',
          text: 'Texto ',
          sortable: true,
        },
        {
          value: 'actions',
          text: 'Ações ',
          sortable: false,
          align: 'right',
        },
      ];
    },
  },
  mounted() {
    this.getTextosEditaveis();
  },
  methods: {
    async getTextosEditaveis(): Promise<void> {
      this.loading = true;
      try {
        const response = await Requester.textoEditavel.textosEditaveis();
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.textosEditaveis = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
  },
});
